import { BaseChatService } from 'shared/services/baseChatService';
import { type DataPayload } from 'types/customEventData';
import { type ZopimChatClient } from 'v1/clients/zopimChatClient';

export class ZopimChatService extends BaseChatService<ZopimChatClient> {
  public constructor(client: ZopimChatClient) {
    super(client);
  }

  async initiateChat(payload?: DataPayload): Promise<void> {
    this.zendeskClient.identify(payload?.visitor_info);

    await super.initiateChat(payload);

    this.zendeskClient.showWidget();

    this.zendeskClient.updateSettings({
      chat: {
        suppress: false,
      },
    });
  }

  onLoadCallback(): void {
    this.zendeskClient.onChatEnd(() => {
      this.zendeskClient.hideWidget();
      this.zendeskClient.logout();
    });
  }
}
